import { mapState } from 'vuex';
import get from 'lodash/get';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsDownlinksActility',
  props: {
    deviceData: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      downlink: [],
      payload: null,
      port: null,
      menu: false,
      confirmed: false,
      flushQueue: false,
      sendingDownlink: false,
      millisecondsDelay: 1000,
      fcnt: null
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {},
  methods: {
    onValueChange(value, item) {
      this[item] = value;
      this.downlink[item] = value;
    },
    isReadyForSend() {
      return this.payload && this.port;
    },
    sendDownlink() {
      this.fcnt = null;
      this.sendingDownlink = true;
      this.downlink = [{
        payload: this.payload,
        port: this.port,
        confirmed: this.confirmed,
        flushQueue: this.flushQueue
      }];
      NiotaClassicApiService.deviceSendDownlinkToActility(this.deviceData.id, this.downlink).then(res => {
        this.fcnt = get(res, 'data.sentPacket.fcnt');
        return new Promise(resolve => setTimeout(resolve, this.millisecondsDelay));
      }).then(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.sentDownlink'), 'success');
      }).finally(() => {
        this.sendingDownlink = false;
      }).catch(error => {
        let apiError = get(error, 'response.data.err');
        this.$snack(apiError || this.$i18n_t('NiotaClassic.Devices.snacks.failedDownlink'), 'error');
      });
    }
  }
};